import React from 'react';

import { QuartileData } from '@/graphql';
import { classNames } from '@/helpers/classNames';

import { FeedbackScale, FeedbackScaleProps } from '../FeedbackScale';
import styles from './QuartileScales.module.scss';

type QuartileScalesProps = {
	className?: string;
	titleClassName?: string;
	equalSpacing?: boolean;
	quartiles?: {
		personalScoreQuartiles: QuartileData | null;
		teamScoreQuartiles: QuartileData | null;
		congregationalScoreQuartiles: QuartileData | null;
	} | null;
	size?: FeedbackScaleProps['size'];
	myPersonalScore?: number | null;
	myTeamScore?: number | null;
	myCongregationalScore?: number | null;
	myPersonalIndicator?: React.ReactNode;
};

export const QuartileScales: React.FC<QuartileScalesProps> = ({
	className,
	titleClassName,
	equalSpacing,
	quartiles,
	size,
	myPersonalScore,
	myTeamScore,
	myCongregationalScore,
	myPersonalIndicator,
}) => {
	const classes = classNames([
		styles['root'],
		equalSpacing && styles['equal-spacing'],
		className,
	]);
	if (!quartiles) {
		return null;
	}

	const {
		personalScoreQuartiles,
		teamScoreQuartiles,
		congregationalScoreQuartiles,
	} = quartiles;

	if (
		!personalScoreQuartiles ||
		!teamScoreQuartiles ||
		!congregationalScoreQuartiles
	) {
		return null;
	}

	return (
		<div className={classes}>
			<div>
				<div
					className={classNames([
						styles['scale-title'],
						titleClassName,
					])}
				>
					Personal Worship of your team
				</div>
				<FeedbackScale
					hasHover={true}
					size={size}
					className={styles['scale']}
					start={personalScoreQuartiles.q1}
					position={personalScoreQuartiles.q2}
					end={personalScoreQuartiles.q3}
					myPosition={myPersonalScore ?? undefined}
					myPositionContent={myPersonalIndicator}
				/>
			</div>
			<div>
				<div
					className={classNames([
						styles['scale-title'],
						titleClassName,
					])}
				>
					Effectiveness of Team Execution
				</div>
				<FeedbackScale
					hasHover={true}
					size={size}
					className={styles['scale']}
					start={teamScoreQuartiles.q1}
					position={teamScoreQuartiles.q2}
					end={teamScoreQuartiles.q3}
					myPosition={myTeamScore ?? undefined}
					myPositionContent={myPersonalIndicator}
				/>
			</div>

			<div>
				<div
					className={classNames([
						styles['scale-title'],
						titleClassName,
					])}
				>
					Church Engagement in singing
				</div>
				<FeedbackScale
					hasHover={true}
					size={size}
					className={styles['scale']}
					start={congregationalScoreQuartiles.q1}
					position={congregationalScoreQuartiles.q2}
					end={congregationalScoreQuartiles.q3}
					myPosition={myCongregationalScore ?? undefined}
					myPositionContent={myPersonalIndicator}
				/>
			</div>
		</div>
	);
};
